import { Channel } from "../interfaces/tracking";

export interface Event {
  channel: Channel;
  name: EventNames;
  data: any;
}

const googleEvent = <T>(name: string, params?: T) => {
  window?.gtag("event", name, params);

  console.log(
    `%cGoogle event: %c${name}`,
    "color: #C0267E; font-weight: bold;",
    "background-color: #f26b1c; color: white; font-weight: bold;",
    params
  );
};

const tealiumEvent = <T>(name: string, params?: T) => {
  window?.utag?.link({
    tealium_event: name,
    ...params,
  });
};

const event = <T>(channel: Channel, name: string, params?: T) => {
  const all = channel === Channel.ALL;

  if (all || channel === Channel.GA) googleEvent(name, params);
  if (all || channel === Channel.TEALIUM) tealiumEvent(name, params);
};

export enum PhotoSource {
  PHOTO = "Photo",
  SAVED_PHOTO = "Saved Photo",
  UPLOAD_PHOTO = "Upload Photo",
}

export enum EventNames {
  BANNER_CLICKED = "banner_clicked",
  CAMERA_LOADED = "camera_loaded",
  CAMERA_READY = "camera_ready",
  PHOTO_CONFIRMATION_LOADED = "photo_confirmation_loaded",
  LOADER_STARTED = "loader_started",
  WIGS_STARTED = "wigs-started",
  STYLES_LOADED = "styles_loaded",
  WIGS_LOADED = "wigs_loaded",
  COLOR_LOADED = "color_loaded",
  LEGAL_LOADED = "legal_loaded",
  ANALYSIS_LEGAL_LOADED = "analysis_legal_loaded",
  ANALYSIS_LEGAL_DENIED = "analysis_legal_denied",
  LEAGAL_ALERT_LOADED = "legal_alert_loaded",
  ANALYSIS_ALERT_LOADED = "analysis_alert_loaded",
  HOME_LOADED = "home_loaded",
  SESSION_EXPIRED_LOADED = "session_expired_loaded",
  IMAGE_FAILED_LOADED = "image_failed_loaded",
  SAVE_PHOTO_LOADED = "save_photo_loaded",
  PHOTO_TAKEN = "photo_taken",
  PHOTO_APPROVED = "photo_approved",
  ANALYSIS_PHOTO_APPROVED = "analysis_photo_approved",
  RETAKE_SELECTED = "retake_selected",
  BACK_SELECTED = "back_selected",
  LEGAL_ACCEPTED = "legal_accepted",
  ANALYSIS_LEGAL_ACCEPTED = "analysis_legal_accepted",
  LEGAL_DENIED = "legal_denied",
  TIPS_ACCEPTED = "tips_accepted",
  PHTO_SELECTED = "photo_selected",
  APPOINTMENT_SELECTED = "appointment_selected",
  COLOR_SELECTED = "color_selected",
  VOLUME_SELECTED = "volume_selected",
  CATEGORY_SELECTED = "category_selected",
  HAIRSTYLE_SELECTED = "hairstyle_selected",
  SAVE_PHOTO_ACCEPTED = "save_photo_accepted",
  SAVE_PHOTO_DENIED = "save_photo_denied",
  VTO_CLICKED = "vto_clicked",
  BUBBLE_CLICKED = "bubble_clicked",
  PRODUCT_CLICKED = "product_clicked",
  DOWNLOAD_CLICKED = "download_clicked",
  SHARE_CLICKED = "share_clicked",
  INTERNAL_VTO_CLICKED = "internal_VTO_clicked",
  SELECT_CONTENT = "select_content",
  SELECT_ITEM = "select_item",
  UPLOAD_SELECTED = "upload_selected",
  NEXT = "next",
  PREVIOUS = "previous",
  VIEW_ITEM_LIST = "view_item_list",
  COLOR_CATEGORY_SELECTED = "color_category_selected",
  QUESTION_1 = "question_1",
  QUESTION_2 = "question_2",
  RESULTS_SHOWN = "results_shown",
  QUESTIONS_CLICKED = "questions_clicked",
  PRODUCT_TAB_CLICKED = "tab_clicked",
  PRODUCT_CLICKED_ANALYSIS = "analysis_product_clicked",
  QUIZ_START = "quiz_start",
  LINK_CLICK = "link_click",
  SORT_CLICKED = "sort_clicked",
  FEEDBACK_INFO = "feedback_info",
  FEEDBACK_SELECTED = "feedback_selected",
}

export const Analytics = { event };
